export enum DetailsPageActions {
  DownloadMedia = '[OrderBook Details] Download Media',
  ExportExcel = '[OrderBook Details] Export to excel',
  PrintOrder = '[OrderBook Details] Print order',
  InvoicesModal = '[OrderBook] invoices-modal',
  ExpandAll = '[OrderBook Details] Expand All',
  CollapseAll = '[OrderBook Details] Collapse All',
  ToggleSorting = '[Order Book Details] Toggle Sorting',
}

export enum ListPageActions {
  TrackingModal = '[OrderBook] tracking-modal',
  InvoicesModal = '[OrderBook] invoices-modal',
  ToggleSorting = '[Order Book] Toggle Sorting',
}
